const activationTypes = {
    Always: {
        value: 1, text: "Always", icon: "mdi-check-all",
        keyConversionType: Boolean
    },
    Customer: {
        value: 2, text: "Customer", icon: "$customer",
        keyConversionType: String, pickerComponent: "CustomerSelect"
    },
    CustomerGroup: {
        value: 3, text: "Customer Group", icon: "$customer_group",
        keyConversionType: String, pickerComponent: "CustomerGroupSelect"
    },
    AnyContract: {
        value: 4, text: "Has Any Contract", icon: "$contract",
        keyConversionType: Boolean
    },
    Contract: {
        value: 5, text: "Contract", icon: "mdi-file-document",
        keyConversionType: Number, pickerComponent: "ContractSelect"
    },
    ContractType: {
        value: 6, text: "Contract Type", icon: "$contract_type",
        keyConversionType: Number
    },
    JobPriority: {
        value: 7, text: "Job Priority", icon: "$job_priority",
        keyConversionType: Number
    },
    MachineModel: {
        value: 8, text: "Machine Model", icon: "$machine_model",
        keyConversionType: Number, pickerComponent: "MachineModelSelect"
    },
    MachineType: {
        value: 9, text: "Machine Type", icon: "$machine_categories",
        keyConversionType: Number, pickerComponent: "MachineTypeSelect"
    },
    JobType: {
        value: 10, text: "Job Type", icon: "$job_type",
        keyConversionType: Number
    },
};

export default Object.freeze({

    templateTypes: {
        1: { text: 'Header' },
        2: { text: 'Per machine' },
        3: { text: 'Footer' }
    },

    fieldTypes: {
        1: { text: 'Checkbox', icon: "mdi-checkbox-marked-outline" },
        2: { text: 'Dropdown List', icon: "mdi-format-list-bulleted" },
        3: { text: 'Radio Button', icon: "mdi-radiobox-marked" },
        4: { text: 'Number', icon: "mdi-numeric" },
        5: { text: 'Text', icon: "mdi-text" }
    },

    activationTypes: activationTypes,
    activationTypeList: Object.values(activationTypes),
    activationTypeMap: Object.fromEntries(Object.values(activationTypes).map(type => [type.value, type])),
});